import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Button, Form, FormGroup, Input } from 'reactstrap';
import { WorkPhaseReportForm } from '../models/investors';

interface Props {
  handleForm: (form: WorkPhaseReportForm) => Promise<void>;
}

const schema = yup
  .object({
    title: yup.string().required('Requerido'),
    description: yup.string().required('Requerido'),
    report_period: yup.string().required('Requerido'),
    published_at: yup.string().required('Requerido'),
  })
  .required();

const WorkPhaseReportCreateForm = ({ handleForm }: Props) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<WorkPhaseReportForm>({
    resolver: yupResolver(schema),
  });

  return (
    <Form role="form" onSubmit={handleSubmit(handleForm)}>
      <FormGroup>
        <label className="form-control-label">Título</label>
        <Controller
          name="title"
          control={control}
          render={({ field }) => (
            <Input
              className={errors.title?.message ? 'is-invalid' : ''}
              type="text"
              placeholder="Novedades de tu futuro hogar · Mar 2026"
              {...field}
            />
          )}
        />
        <h5 className="text-danger mt-1">{errors.title?.message}</h5>
      </FormGroup>
      <FormGroup>
        <label className="form-control-label">Descripción</label>
        <Controller
          name="description"
          control={control}
          render={({ field }) => (
            <Input
              className={errors.description?.message ? 'is-invalid' : ''}
              type="textarea"
              rows={3}
              {...field}
            />
          )}
        />
        <h5 className="text-danger mt-1">{errors.description?.message}</h5>
      </FormGroup>
      <FormGroup>
        <label className="form-control-label">Período del reporte</label>
        <Controller
          name="report_period"
          control={control}
          render={({ field }) => (
            <Input
              className={errors.report_period?.message ? 'is-invalid' : ''}
              type="date"
              {...field}
            />
          )}
        />
        <h5 className="text-danger mt-1">{errors.report_period?.message}</h5>
      </FormGroup>
      <FormGroup>
        <label className="form-control-label">Fecha de publicación</label>
        <Controller
          name="published_at"
          control={control}
          render={({ field }) => (
            <Input
              className={errors.published_at?.message ? 'is-invalid' : ''}
              type="date"
              {...field}
            />
          )}
        />
        <h5 className="text-danger mt-1">{errors.published_at?.message}</h5>
      </FormGroup>
      <Button color="success">Crear reporte</Button>
    </Form>
  );
};

export default WorkPhaseReportCreateForm;
